import React, { useState } from 'react';
// import { useDrag, DragPreviewImage } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { Tooltip, Dialog } from '@material-ui/core';
import './cardmini.css';
import '../../res/placeholder.png';

const Cardmini = ({ cardInfo, isDraggable, index }) => {
    const [isHovering, setHovering] = useState(false);
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const img_url = `/images/${cardInfo.mini_img?.replace(/\.png$/i, '.webp')}`;
    
    const handleClickOpen = () => setOpen(true);
    const handleClose = () => { setOpen(false); setHovering(false); };
    
    const handleClick = (event) => {
        setHovering(false); // Disables tooltip
        if (event.buttons === 2) { // If right-click opens modal
            handleClickOpen();
            event.preventDefault();
            return false;
        }
    };
    
    // const [, drag, conn] = useDrag({
    //     item: { type: "Cardmini", card: cardInfo },
    // });
    
    const TooltipDisplay = (
        <div>
            {cardInfo.Nombre && <span>Nombre: {cardInfo.Nombre}<br /></span>}
            {cardInfo.Tipo && <span>Tipo: {cardInfo.Tipo}<br /></span>}
            {cardInfo.Raza && <span>Raza: {cardInfo.Raza}<br /></span>}
            {cardInfo.Fuerza && <span>Fuerza: {cardInfo.Fuerza}<br /></span>}
            {cardInfo.Coste && <span>Coste: {cardInfo.Coste}<br /></span>}
            {cardInfo.Habilidad && <span>Habilidad: {cardInfo.Habilidad}<br /></span>}
        </div>
    );
    
    // const DialogDisplay = (
    //     <div className="card-modal">
    //         {cardInfo.url_api && <img src={cardInfo.url_api} alt={cardInfo.Nombre} />}
    //         <div>
    //             {cardInfo.Nombre && <h6>{cardInfo.Nombre}<br /></h6>}
    //             {cardInfo.Tipo && <span>Tipo: {cardInfo.Tipo}<br /></span>}
    //             {cardInfo.Raza && <span>Raza: {cardInfo.Raza}<br /></span>}
    //             {cardInfo.Fuerza && <span>Fuerza: {cardInfo.Fuerza}<br /></span>}
    //             {cardInfo.Coste && <span>Coste: {cardInfo.Coste}<br /></span>}
    //             {cardInfo.Habilidad && <span>Habilidad: {cardInfo.Habilidad}<br /></span>}
    //         </div>
    //     </div>
    // );
    
    return (
        <Tooltip title={TooltipDisplay} placement="right" open={isHovering && !open} onClose={handleClose}>
            <div className="card-mini" onMouseOver={() => setHovering(true)} onMouseOut={() => setHovering(false)}>
                {/* <DragPreviewImage src={img_url} connect={conn} /> */}
                <img 
                    src={img_url} 
                    // ref={isDraggable ? drag : null} 
                    alt={cardInfo.Nombre} 
                    className="card-mini-image" 
                    onMouseDown={e => handleClick(e)} 
                    onClick={() => isDraggable ? dispatch({ type: 'ADD_CARD_TO_DECK', payload: cardInfo }) : dispatch({ type: 'REMOVE_CARD', index, payload: { type: cardInfo.type } })} 
                />
                <span className="card-name">{cardInfo.Nombre}</span>
                {/* <Dialog open={open} onClose={handleClose} onBackdropClick={() => setOpen(false)} maxWidth="md">
                    {DialogDisplay}
                </Dialog> */}
            </div>
        </Tooltip>
    );
};

export default Cardmini;
